import { render, staticRenderFns } from "./CustomFieldForm.vue?vue&type=template&id=fb6d8476&"
import script from "./CustomFieldForm.vue?vue&type=script&lang=js&"
export * from "./CustomFieldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6d8476')) {
      api.createRecord('fb6d8476', component.options)
    } else {
      api.reload('fb6d8476', component.options)
    }
    module.hot.accept("./CustomFieldForm.vue?vue&type=template&id=fb6d8476&", function () {
      api.rerender('fb6d8476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/components/CustomFieldForm.vue"
export default component.exports